import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-request-data-petitioner-display',
  templateUrl: './request-data-petitioner-display.component.html',
  styleUrls: ['./request-data-petitioner-display.component.scss']
})
export class RequestDataPetitionerDisplayComponent implements OnInit {

  @ViewChild('dataLogComponent', { static: false }) dataLogComponent: any;
  beneficiaryDetails: any;
  index = 0;


  constructor(private route: ActivatedRoute) {
    this.route.queryParams.subscribe(
      params => {
        // console.log('paramsparams', params);
        this.beneficiaryDetails = params;
      }
    )
   }

   ngOnInit(): void { }

   handleChange(e) {
     //if Data log tab is selected then only call this method
     if(e.index === 1){
       this.dataLogComponent.getDataLogList();
     }
   }

}
